export default __webpack_public_path__ + "static/media/internet-tv.9d630241.png";